export default __webpack_public_path__ + "static/media/invoice-csv-icon.04ad2cba.svg";